var _circle, _circle2, _path, _g, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
function SvgPuzzle(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 640,
    height: 217,
    viewBox: "0 0 640 217",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 8,
    transform: "matrix(1 0 0 -1 9 109)",
    stroke: "#67466C",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    r: 8,
    transform: "matrix(1 0 0 -1 631 109)",
    stroke: "#67466C",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M427.5 108.5c0 59.371-48.129 107.5-107.5 107.5s-107.5-48.129-107.5-107.5m215 0C427.5 49.13 379.371 1 320 1S212.5 49.13 212.5 108.5m215 0h195m-410 0H17",
    stroke: "#67466C",
    strokeLinecap: "round",
    strokeDasharray: "14 14"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    filter: "url(#puzzle_svg__filter0_d_36_3570)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 320.5,
    cy: 109,
    r: 82,
    fill: "#BEF6FE"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M314.667 114.578l-4.977-4.971c-.07-.07-.191-.007-.176.091.055.365.083.74.083 1.12 0 4.218-3.479 7.636-7.77 7.636a7.943 7.943 0 01-1.971-.247m14.811-3.629v-5.386c.07-1.753 1.337-5.302 5.842-5.473 5.631-.213 6.672 4.095 6.672 5.473v3.895m-12.514 1.491v16.586m12.514-18.077l3.709-3.67c.069-.069.189-.007.175.09a7.625 7.625 0 00-.075 1.064c0 4.217 3.479 7.636 7.77 7.636.183 0 .364-.007.543-.019m-12.122-5.101v12.333m0 0v3.341c-.018.916.17 3.582 1.879 6.446.968 1.43 2.417 5.55-.355 11.061-.503.835-1.509 3.35-1.509 6.732m-.015-27.58c1.315 1.984 4.932 5.887 8.882 5.629 1.08-.005 3.24-.515 3.24-2.515v-10.346m0 0c4.038-.274 7.227-3.579 7.227-7.617 0-4.218-3.479-7.636-7.77-7.636-.386 0-.78.042-1.158.102-.097.015-.159-.105-.089-.174l9.595-9.494a1.556 1.556 0 00.005-2.21l-8.189-8.18c-.058-.057-.158-.024-.173.056-.637 3.587-3.821 6.314-7.653 6.314-4.292 0-7.77-3.42-7.77-7.636 0-3.824 2.822-6.978 6.552-7.535.083-.013.118-.114.059-.173l-8.555-8.545a1.577 1.577 0 00-2.221-.005l-9.415 9.316c-.068.067-.183.011-.175-.083a7.72 7.72 0 00.024-.611c0-4.218-3.479-7.636-7.77-7.636-4.291 0-7.77 3.418-7.77 7.636 0 4.217 3.479 7.636 7.77 7.636.227 0 .452-.01.674-.029.095-.008.15.109.083.176l-9.271 9.174a1.555 1.555 0 00-.006 2.209l9.876 9.864c.07.071.006.192-.092.176a7.976 7.976 0 00-1.264-.1c-4.291 0-7.77 3.418-7.77 7.635 0 3.548 2.462 6.531 5.799 7.389m0 0l-3.843 11.81c-.336.95-.668 3.425.693 5.73 1.36 2.304 4.304 9.602 5.606 12.963.105.376.315 1.76.315 4.29m-14.677-42.578l-8.902 5.176m7.364-22.355H276m11.922-17.256l-8.874-5.176m74.94 5.28l9.07-5.342m-7.587 22.62H366m-12.085 17.076l9.045 5.173",
    stroke: "#1E7282",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "puzzle_svg__filter0_d_36_3570",
    x: 226.5,
    y: 27,
    width: 188,
    height: 188,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 12
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0677643 0 0 0 0 0.26974 0 0 0 0 0.306463 0 0 0 0.33 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_36_3570"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_36_3570",
    result: "shape"
  })))));
}
export default SvgPuzzle;